module.exports = function _forceReduced(x) {
  return {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ramda/src/internal/_forceReduced.js
 ** module id = 3098
 ** module chunks = 0
 **/